import React, { useEffect, useState } from 'react'
import InputField from '../../../feature-module/components/Input'
import { useForm } from 'react-hook-form'
import { ErrorToaster, SuccessToaster } from '../../../feature-module/components/toaster/Toaster'
import SupplierServices from '../../../services/Supplier'
import { emailRegex } from '../../../utils'
import { modalCloseListener } from '../../../utils/helper'

const SupplierModal = ({ updateData, resetUpdateData, getData }) => {

  const { register, handleSubmit, formState: { errors }, setValue, reset } = useForm();
  const [loading, setLoading] = useState(false);

  // *For Submit Form
  const submitForm = async (formData) => {
    setLoading(true)
    try {
      let obj = {
        name: formData?.name,
        phone_number: formData?.phone,
        email: formData?.email,
        address: formData?.address,
        remarks: formData?.remarks,
        website: formData?.website,
        gst_number: formData?.gst,
        ntn_number: formData?.ntn,
        is_active: formData?.status
      }
      if (updateData?.id) {
        // *Update 
        await SupplierServices.updateSupplier(updateData?.id, obj)
        SuccessToaster('Update Successfully')
      } else {
        // *Create 
        await SupplierServices.createSupplier(obj)
        SuccessToaster('Create Successfully')
      }
      reset();
      const btn = document.getElementById('modalClose')
      btn.click();
      getData();
    } catch (error) {
      ErrorToaster(error)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    if (updateData) {
      setValue('name', updateData?.name)
      setValue('phone', updateData?.phone_number)
      setValue('email', updateData?.email)
      setValue('address', updateData?.address)
      setValue('remarks', updateData?.remarks)
      setValue('website', updateData?.website)
      setValue('gst', updateData?.gst_number)
      setValue('ntn', updateData?.ntn_number)
      setValue('status', updateData?.is_active)
    }
  }, [updateData]);

  useEffect(() => {
    const cleanup = modalCloseListener("open-modal", () => {
      reset();
      resetUpdateData();
    });

    return cleanup;
  }, []);

  return (
    <div className="modal fade" id="open-modal">
      <div className="modal-dialog modal-dialog-centered custom-modal-two">
        <div className="modal-content">
          <div className="page-wrapper-new p-0">
            <div className="content">
              <div className="modal-header border-0 custom-modal-header">
                <div className="page-title">
                  <h4>{updateData?.id ? "Update Supplier" : "Create Supplier"}</h4>
                </div>
                <button
                  type="button"
                  className="close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                >
                  <span aria-hidden="true">×</span>
                </button>
              </div>
              <div className="modal-body custom-modal-body">
                <form onSubmit={handleSubmit(submitForm)}>
                  <div className="row">
                    <div className="col-lg-6">
                      <div className="input-blocks">
                        <InputField
                          label="Name"
                          type="text"
                          error={errors?.name?.message}
                          register={register("name", {
                            required: 'Please enter supplier name.',
                          })}
                        />
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <div className="input-blocks">
                        <InputField
                          label="Phone"
                          type="tel"
                          error={errors?.phone?.message}
                          register={register("phone", {
                            required: 'Please enter phone.',
                          })}
                        />
                      </div>
                    </div>
                    <div className="col-lg-12">
                      <div className="input-blocks">
                        <InputField
                          label="Email"
                          type="email"
                          error={errors?.email?.message}
                          register={register("email", {
                            required: 'Please enter billing email.',
                            pattern: {
                              value: emailRegex,
                              message: 'Please enter a valid email.',
                            }
                          })}
                        />
                      </div>
                    </div>
                    <div className="col-lg-12">
                      <div className="input-blocks">
                        <InputField
                          label="Address"
                          type="text"
                          error={errors?.address?.message}
                          register={register("address", {
                            required: 'Please enter address.',
                          })}
                        />
                      </div>
                    </div>
                    <div className="col-lg-12">
                      <div className="input-blocks">
                        <InputField
                          label="Website"
                          type="text"
                          register={register("website")}
                        />
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <div className="input-blocks">
                        <InputField
                          label="GST No"
                          type="text"
                          register={register("gst")}
                        />
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <div className="input-blocks">
                        <InputField
                          label="NTN/Tax No"
                          type="text"
                          register={register("ntn")}
                        />
                      </div>
                    </div>
                    <div className="col-md-12">
                      <div className="input-blocks">
                        <InputField
                          label="Remarks"
                          inputType="textarea"
                          placeholder="Type Remarks"
                          register={register("remarks")}
                        />
                      </div>
                    </div>
                    <div className="col-md-12">
                      <div className="status-toggle modal-status d-flex justify-content-between align-items-center">
                        <span className="status-label">Status</span>
                        <InputField
                          id="checkbox1"
                          type="checkbox"
                          className="check"
                          defaultChecked={true}
                          register={register("status")}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="modal-footer-btn">
                    <button
                      id="modalClose"
                      type="button"
                      className="btn btn-cancel me-2"
                      data-bs-dismiss="modal"
                    >
                      Cancel
                    </button>
                    <button
                      type="submit"
                      className="btn btn-submit"
                      disabled={loading}
                    >
                      Submit
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SupplierModal;
